/**
 * I mattoni che più contesti usano, e che quindi non appartengono a nessuno.
 *
 * Stanno in un file loro per la stessa ragione di `ruoli.ts`: se abitassero in
 * `ricezione.ts` — dove sono nati — allora `flusso.ts` dovrebbe importare la
 * ricezione per validare una taglia, e i contesti smetterebbero di essere
 * leggibili uno alla volta.
 */
import { z } from 'zod';
export const zTaglia = z.string().min(1).max(8);
export const zCodiceCassetta = z.string().regex(/^[A-Z][0-9]{1,4}$/, 'codice cassetta non valido');
/**
 * La forma con cui il backend risponde a un comando. Il rifiuto **non è un
 * errore HTTP**: è una risposta legittima che porta il motivo da mostrare
 * all'operatore, esattamente come nel prototipo.
 */
export const zEsitoComando = z.discriminatedUnion('ok', [
    z.object({
        ok: z.literal(true),
        titolo: z.string(),
        messaggio: z.string(),
    }),
    z.object({
        ok: z.literal(false),
        titolo: z.string(),
        motivo: z.string(),
        regola: z.string(),
    }),
]);
//# sourceMappingURL=primitives.js.map